const SetupAdvancedCustomerAccountActionTypes = {
  GET_ADVANCED_CUSTOMER_ACCOUNT_START: 'GET_ADVANCED_CUSTOMER_ACCOUNT_START',
  GET_ADVANCED_CUSTOMER_ACCOUNT_SUCCESS: 'GET_ADVANCED_CUSTOMER_ACCOUNT_SUCCESS',
  GET_ADVANCED_CUSTOMER_ACCOUNT_FAILURE: 'GET_ADVANCED_CUSTOMER_ACCOUNT_FAILURE',
};

export default SetupAdvancedCustomerAccountActionTypes;
